import { useMutation } from "@tanstack/react-query";
import { updateSplashTimeout } from "../../api/unifiApi";

export const useUpdateUnifiSplashTimeout = () => {
  return useMutation({
    mutationFn: (data) => updateSplashTimeout(data),
    onSuccess: (response) => {
      console.log("UniFi splash timeout updated successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error updating UniFi splash timeout:", error);
    },
  });
};